import telegramUser from './content-type/telegram-user';
import telegramGroup from './content-type/telegram-group';
import telegramLink from "./content-type/telegram-link";
import telegramUserActivity from "./content-type/telegram-user-activity";
import telegramAction from './api/telegram-action';

export default {
  'telegram-user': telegramUser,
  'telegram-group': telegramGroup,
  'telegram-link': telegramLink,
  'telegram-user-activity': telegramUserActivity,
  telegramAction
};
